<template>
  <div class="message__container" @focusout="callRemovedMovedAction">
    <CdrLink
      ref="statusItem"
      :href="`/product/${itemRemovedMoved.sku}`"
      modifier="standalone"
      @click="handleMetric('Product title')"
      @focusin="setFocus(true)"
      @focusout="setFocus(false)"
    >
      {{ itemRemovedMoved.description }}
    </CdrLink>
    <span>{{ getActionText }}</span>
    <CdrLink
      v-if="itemRemovedMoved.newListId"
      ref="newList"
      :href="`/lists/${itemRemovedMoved.newListId}`"
      modifier="standalone"
      @focusin="setFocus(true)"
      @focusout="setFocus(false)"
    >
      {{ itemRemovedMoved.newListName }}
    </CdrLink>
  </div>
</template>

<script>
import { CdrLink } from '@rei/cedar';
import { mapActions, mapState } from 'pinia';
import metrics from '../../utils/metrics';
import { useWishlistStore } from '../../stores';

export default {
  name: 'WishlistDetailMessageComponent',
  components: {
    CdrLink,
  },
  data() {
    return {
      linkFocus: false,
    };
  },
  computed: {
    ...mapState(useWishlistStore, ['itemRemovedMoved']),
    getActionText() {
      return this.itemRemovedMoved.newListId ? ' has been moved to the list ' : ' has been removed.';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.statusItem.$el.focus();
    });
  },
  methods: {
    ...mapActions(useWishlistStore, ['moveItemFromLocalStorage', 'deleteItemFromLocalStorage']),
    handleMetric(metric) {
      metrics.metricsClick(metric);
    },
    setFocus(isLinkFocus) {
      this.linkFocus = isLinkFocus;
    },
    callRemovedMovedAction() {
      setTimeout(() => {
        if (this.linkFocus) {
          return;
        }
        const objectToRemovedMoved = {
          listId: this.itemRemovedMoved.listId,
          item: this.itemRemovedMoved.item,
          description: this.itemRemovedMoved.description,
          sku: this.itemRemovedMoved.sku,
        };
        if (this.itemRemovedMoved.newListId) {
          objectToRemovedMoved.newListId = this.itemRemovedMoved.newListId;
          objectToRemovedMoved.newListName = this.itemRemovedMoved.newListName;
          this.moveItemFromLocalStorage(objectToRemovedMoved);
        } else {
          this.deleteItemFromLocalStorage(objectToRemovedMoved);
        }
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  vertical-align: middle;

  &__container {
    align-items: center;
  }
}
</style>
